import { z } from "zod";
import { defineNotificationHandler } from "./types";

const MessageNewSchema = z.object({
  conversationId: z.string(),
  senderId: z.string(),
  senderName: z.string(),
  content: z.string(),
});

export const messageNewHandler = defineNotificationHandler({
  type: "message.new",
  // Email is handled by the unread-conversation cron, not per message.
  icon: "message",
  title(metadata) {
    const senderName =
      typeof metadata.senderName === "string" && metadata.senderName.trim()
        ? metadata.senderName
        : undefined;
    return `New message from ${senderName ?? "Vacwork user"}`;
  },
  description(metadata) {
    const content =
      typeof metadata.content === "string" && metadata.content.trim()
        ? metadata.content
        : undefined;
    return content ?? "Open the conversation to view the message.";
  },
  schema: MessageNewSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        conversationId: data.conversationId,
        senderId: data.senderId,
        senderName: data.senderName,
        content: String(data.content ?? "").substring(0, 120),
      },
      links: {
        href: `/conversations/${data.conversationId}`,
        label: "View conversation",
      },
    };
  },
});
